import loadable from '@loadable/component';

/* istanbul ignore next */
export const SerialCodeInputModal = loadable(() =>
    import(
        /* webpackChunkName: "CartPageModalsLazy" */ 'yoda-checkout-components/lib/components/Coupons/SerialCodeInputModal/SerialCodeInputModal'
    )
);

/* istanbul ignore next */
export const CouponsPanel = loadable(() =>
    import(
        /* webpackChunkName: "CartPageModalsLazy" */ 'yoda-checkout-components/lib/components/Coupons/CouponsPanel'
    )
);

/* istanbul ignore next */
export const ShowRewardsPanel = loadable(() =>
    import(
        /* webpackChunkName: "CartPageModalsLazy" */ 'yoda-checkout-components/lib/components/ShowRewardsPanel/ShowRewardsPanel'
    )
);

/* istanbul ignore next */
export const SessionTimeoutModal = loadable(() =>
    import(
        /* webpackChunkName: "CartPageModalsLazy" */ 'yoda-checkout-components/lib/components/SessionTimeoutModal/SessionTimeoutModal'
    )
);
